// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"m3-z"};